exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-select-component .select {\n  width: 100%;\n}\n.app-select-component .select select {\n  width: 100%;\n  height: 40px;\n  box-shadow: none;\n  border: 2px solid #E3E6E8;\n  border-radius: 5px;\n}", ""]);

// exports
